import { Length } from "@siteimprove/alfa-css";
import { None, Option } from "@siteimprove/alfa-option";
import { Media } from "./media.js";
import { Resolver } from "./resolver.js";
/**
 * {@link https://drafts.csswg.org/mediaqueries-5/#height}
 *
 * @public
 */
export class Height extends Media {
    static of(value) {
        return new Height(Option.of(value));
    }
    static _boolean = new Height(None);
    constructor(value) {
        super("height", value);
    }
    static boolean() {
        return Height._boolean;
    }
    matches(device) {
        const { viewport: { height }, } = device;
        const value = this._value.map((value) => value.map((length) => length.resolve(Resolver.length(device))));
        return height > 0
            ? value.some((value) => value.matches(Length.of(height, "px")))
            : value.every((value) => value.matches(Length.of(0, "px")));
    }
}
/**
 * @public
 */
(function (Height) {
    function from(value) {
        return value.map(Height.of).getOrElse(Height.boolean);
    }
    function isHeight(value) {
        return value instanceof Height;
    }
    Height.isHeight = isHeight;
    Height.parse = Media.parseContinuous("height", from);
})(Height || (Height = {}));
//# sourceMappingURL=height.js.map